export default "__VITE_ASSET__1N2FRKV5__"